<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form
            v-if="isSearch"
            :model="queryForm"
            ref="form"
            label-width="80px"
            :inline="true"
            size="small"
            class="query-form"
            @submit.native.prevent
        >
            <el-form-item label="数据类型">
                <el-select
                    v-model="queryForm.type"
                    placeholder="请选择数据类型"
                    style="width: 175px"
                >
                    <el-option
                        v-for="(item,index) in reportDataTypeUserEnumList"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="排行时间">
<!--                <el-input v-model="queryForm.time" placeholder="请填写登录账号" style="width: 175px"></el-input>-->
                <el-date-picker
                    @change="changeDataTiem"
                    v-model="dataValue"
                    type="daterange"
                    align="right"
                    unlink-panels
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>
            <el-form-item style="margin-left: 80px">
                <el-button size="small" type="primary" icon="el-icon-search" @click="getRankingList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class='page-tool-bar'>
                <div class='el-btn-group'></div>
                <div class="icon-group">
                    <span title="搜索" class="icon-box" @click="search">
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>
                </div>
            </div>
            <el-table
                :data="shopUserRankingList"
                height='100%'
                border
                stripe
                style="width: 100%">
                <el-table-column
                    prop="rank"
                    label="排名"
                    align='center'>
                </el-table-column>
                <el-table-column
                    prop="userName"
                    label="用户信息"
                    align='center'>
                    <template slot-scope="scope">
                        <div>账号：{{ scope.row.userName }}</div>
                        <div>手机：{{ scope.row.userMobile }}</div>
                        <div>昵称：{{ scope.row.userNickname }}</div>
                        <div>姓名：{{ scope.row.userRealname }}</div>
<!--                        <div v-if="scope.row.userName">{{scope.row.userName}}</div>-->
<!--                        <el-tag v-else type="danger">门店不存在或已关闭</el-tag>-->
                    </template>
                </el-table-column>
                <el-table-column
                    prop="totalValue"
                    label="数值"
                    align='center'>
                </el-table-column>
            </el-table>
            <div class='pagination-box'>
                <el-pagination
                    @size-change='sizeChange'
                    @current-change='currentChange'
                    :current-page.sync='currentPage'
                    :page-sizes='[50, 100, 200, 500]'
                    :page-size='pageSize'
                    layout='total, sizes, prev, pager, next, jumper'
                    :total='totalNum'
                    background
                    :pager-count='7'
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, get, post, deleteFun } from '@/utils/request.js';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    data(){
        return{
            pageSize: 50,
            currentPage: 1,
            totalNum: 0,
            shopUserRankingList: [],
            reportDataTypeUserEnumList: [],
            isSearch: false,
            queryForm:{
                type: "",
                startDate: "",
                endDate: "",
            },
            dataValue: ["",""],

            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近半年',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一年',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
        }
    },
    created() {
        // this.getRankingList();
        this.getEnum();
    },
    methods:{
        search() {
            this.isSearch = !this.isSearch;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getRankingList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getRankingList();
        },
        resetDialog() {
            this.queryForm = {
                type: "",
                startDate: "",
                endDate: "",
            };
            this.getRankingList();
        },
        changeDataTiem(time){
            this.queryForm.startDate = time[0];
            this.queryForm.endDate = time[1];
        },
        getRankingList(){
            get('/report/reportdailyuser/getRanking', {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                if (res.success) {
                    this.shopUserRankingList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        getEnum(){
            get("/shop/utils/getEnum", {
                enumType: 'report_data_type_user'
            }).then((res)=>{
                if(res.success){
                    this.reportDataTypeUserEnumList = res.enumList;
                }
            })
        },
    }
}
</script>

<style scoped lang="scss">

</style>